import { FormContextValues, NumberPatternType } from '@dreryk/react-common';

import { isNull } from '~libs.typescript';

import { translationKeys } from '../../../translations';

import { GroupSessionsMinParticipantsFieldFormBeanPart } from './GroupSessionsMinParticipantsField.types';
import { StyledNumberInput } from './GroupSessionsMinParticipantsField.styled';

const MIN_PARTICIPANTS_MIN_VALUE = 2;
const MIN_PARTICIPANTS_STEP_VALUE = 1;
const MIN_PARTICIPANTS_DEFAULT_VALUE = 2;

type GroupSessionsMinParticipantsFieldProps = Pick<
   FormContextValues<GroupSessionsMinParticipantsFieldFormBeanPart>,
   'register' | 'getValue' | 'setValue'
>;

export const GroupSessionsMinParticipantsField = (props: GroupSessionsMinParticipantsFieldProps): JSX.Element => {
   return (
      <StyledNumberInput
         testId={'minParticipants'}
         controller={props.register('minParticipants', {
            validate: (value) => {
               const minParticipants = value as number | null;
               const maxParticipants = props.getValue('maxParticipants');

               if (isNull(minParticipants)) {
                  props.setValue('minParticipants', MIN_PARTICIPANTS_DEFAULT_VALUE);
                  return true;
               }

               if (minParticipants < MIN_PARTICIPANTS_MIN_VALUE) {
                  props.setValue('minParticipants', MIN_PARTICIPANTS_MIN_VALUE);
                  return true;
               }

               if (maxParticipants && minParticipants > maxParticipants) {
                  props.setValue('minParticipants', maxParticipants);
                  return true;
               }

               return true;
            },
            required: true,
         })}
         label={translationKeys.minParticipants}
         defaultValue={MIN_PARTICIPANTS_DEFAULT_VALUE}
         stepValue={MIN_PARTICIPANTS_STEP_VALUE}
         pattern={NumberPatternType.POSITIVE_INTEGER}
      />
   );
};
